import type { Core } from 'chessboard/core/config/types';
import type { EventEmitterUtil } from '@chesscom/web-ui';
import { createCoreEvent } from 'chessboard/core/model/create-core-event';

/**
 * Create the respond function.
 */
export function createRespond(emitter: EventEmitterUtil.EventEmitter) {
  /**
   * Respond by emitting a core event and returning it.
   */
  return function respond<U>(type: Core.APIEvents | any, data?: U): Core.Event<Core.APIEvents, U> {
    const event = createCoreEvent(type, data);

    emitter.emit(type, event);

    return event;
  };
}
